import { Link, usePage } from "@inertiajs/react"

import { useNavPermissions } from "@/hooks/use-nav-permissions"
import { findActiveIndex, iconNavPermissions, navItems } from "@/lib/nav-data"

export function IconNav() {
  const { url } = usePage()
  const currentPath = url.split("?")[0]
  const perms = useNavPermissions()

  const filteredItems = navItems.filter((item) => {
    const check = iconNavPermissions[item.label]
    if (check && !check(perms)) return false
    return true
  })

  const activeIndex = findActiveIndex(filteredItems, currentPath)

  return (
    <nav className="border-hpi-light-gray bg-hpi-light-gray flex w-[72px] shrink-0 flex-col border-r">
      <div className="flex flex-1 flex-col items-center gap-0.5 pt-2">
        {filteredItems.map((item, index) => {
          const active = index === activeIndex
          const Icon = item.icon
          const isPlaceholder = item.href.startsWith("#")

          return (
            <Link
              key={item.label}
              href={item.href}
              prefetch={!isPlaceholder}
              className={`relative flex w-full flex-col items-center gap-0.5 px-1 py-2 text-center text-[10px] leading-tight transition-colors ${
                active
                  ? "text-hpi-active-blue font-medium"
                  : "text-hpi-dark-gray hover:text-hpi-active-blue hover:bg-hpi-pale-blue"
              } `}
            >
              {active && (
                <div className="bg-hpi-active-blue absolute top-1 bottom-1 left-0 w-[3px] rounded-r" />
              )}
              <Icon className="h-5 w-5" strokeWidth={active ? 2 : 1.5} />
              <span>{item.label}</span>
            </Link>
          )
        })}
      </div>
    </nav>
  )
}
